import React from "react";
import CommonMigration from "./CommonMigration";

const FOMigration = () => {
  const api = {
    check: "migration/patient/upload/",
    start: "migration/patient/upload/",
    progress: "migration/patient/upload/",
    download: "migration/patient/upload/",
  };

  return <CommonMigration moduleName="patient_demographics" api={api} />;
};

export default FOMigration;